<template>
  <div class="live-commentary-animation">
    <div class="live-commentary-animation-main">
      <img
        src="../images/bg.png"
        class="position-center live-commentary-animation-bg"
      >
      <img
        src="../images/color.png"
        class="position-center live-commentary-animation-color"
      >
      <img
        src="../images/light1.png"
        class="position-center live-commentary-animation-light1"
      >
      <img
        src="../images/light2.png"
        class="position-center live-commentary-animation-light2"
      >
      <div class="position-center live-commentary-animation-ball-wrap">
        <img
          src="../images/ball.png"
          class="live-commentary-animation-ball"
        >
      </div>
      <img
        src="../images/goal.png"
        class="position-center live-commentary-animation-goal"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'MsgAnimation'
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.live-commentary-animation {
  position: fixed;
  z-index: 1002;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, 80%);

  &-main {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 250/@rem;
    height: 250/@rem;
    margin: auto;
    // overflow: hidden;
    .position-center {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
    }
  }

  &-bg,
  &-color,
  &-light1,
  &-light2 {
    width: 100%;
  }

  &-color {
    animation: fade_in 0.3s ease-in-out 0.6s forwards;
    opacity: 0;
  }

  &-light1 {
    animation: light1 0.5s ease-in-out 0.6s 2;
    transform-origin: 8.4% 9.6%;
  }

  &-light2 {
    animation: light2 0.5s ease-in-out 0.6s 2;
    transform-origin: 91.6% 9.6%;
  }

  &-ball-wrap {
    animation: goal_line 0.6s linear forwards;
    transform: translate(30%, 0%);
  }

  &-ball {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 41/@rem;
    animation: ball 0.6s linear forwards;
    transform-origin: 50% 50%;
  }

  &-goal {
    width: 123/@rem;
    animation: shake 1s linear 0.7s forwards;
    opacity: 0;
    transform-origin: 50% 100%;
  }
}

@keyframes light1 {
  0% {
    transform: rotateZ(0);
  }

  50% {
    transform: rotateZ(30deg);
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes light2 {
  0% {
    transform: rotateZ(0);
  }

  50% {
    transform: rotateZ(-30deg);
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes ball {
  0% {
    transform: rotateZ(0) scale(1.3);
  }

  100% {
    transform: rotateZ(-1200deg) scale(0.55);
  }
}

@keyframes goal_line {
  0% {
    transform: translate(30%, 0%);
  }

  30% {
    transform: translate(-12%, -40%);
  }

  100% {
    transform: translate(-50%, -30%);
  }
}

@keyframes fade_in {
  from {
    opacity: 0;
    transform: scale(0);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes shake {
  0% {
    opacity: 0;
    transform: rotateZ(0);
  }

  20% {
    opacity: 1;
    transform: rotateZ(6deg);
  }

  40% {
    opacity: 1;
    transform: rotateZ(-6deg);
  }

  60% {
    opacity: 1;
    transform: rotateZ(6deg);
  }

  80% {
    opacity: 1;
    transform: rotateZ(-6deg);
  }

  100% {
    opacity: 1;
    transform: rotateZ(0);
  }
}
</style>
